/** FIFA Ultimate Team Icon shield — clipPathUnits objectBoundingBox.
 *  Outer = card silhouette. Photo = same shape inset as a foil Rand,
 *  with extra room kept at the bottom tip. */
export function FifaShieldClip() {
  return (
    <svg className="fifa-shield-defs" aria-hidden width="0" height="0">
      <defs>
        <clipPath id="un8-fifa-shield" clipPathUnits="objectBoundingBox">
          <path d="M0.5 0.006 C0.455 0.006 0.405 0.028 0.37 0.04 L0.3 0.052 C0.24 0.06 0.16 0.048 0.11 0.06 L0.078 0.078 L0.055 0.12 L0.055 0.62 L0.028 0.645 L0.028 0.705 L0.055 0.73 C0.055 0.82 0.22 0.92 0.5 0.992 C0.78 0.92 0.945 0.82 0.945 0.73 L0.972 0.705 L0.972 0.645 L0.945 0.62 L0.945 0.12 L0.922 0.078 C0.88 0.06 0.8 0.06 0.7 0.052 L0.63 0.04 C0.595 0.028 0.545 0.006 0.5 0.006 Z" />
        </clipPath>
        <clipPath id="un8-fifa-shield-photo" clipPathUnits="objectBoundingBox">
          {/* Thin foil Rand (~3–4%); tip ~0.94 keeps a slight chin. */}
          <path d="M0.5 0.022 C0.47 0.022 0.43 0.036 0.4 0.046 L0.34 0.056 C0.285 0.062 0.205 0.055 0.155 0.065 L0.12 0.082 L0.085 0.115 L0.085 0.6 L0.06 0.62 L0.06 0.675 L0.085 0.70 C0.085 0.78 0.24 0.88 0.5 0.94 C0.76 0.88 0.915 0.78 0.915 0.70 L0.94 0.675 L0.94 0.62 L0.915 0.6 L0.915 0.115 L0.88 0.082 C0.84 0.065 0.76 0.062 0.66 0.056 L0.6 0.046 C0.57 0.036 0.53 0.022 0.5 0.022 Z" />
        </clipPath>
      </defs>
    </svg>
  );
}
